import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Mail } from 'lucide-react';
import { useTheme } from '@/contexts/ThemeContext';
import { cn } from '@/lib/utils';
interface SubscribeDialogProps {
  isOpen: boolean;
  onClose: () => void;
}
const SubscribeDialog: React.FC<SubscribeDialogProps> = ({
  isOpen,
  onClose
}) => {
  const [email, setEmail] = useState('');
  const {
    resolvedTheme
  } = useTheme();
  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !email.includes('@')) return;
    console.log("Subscribed email:", email);
    setEmail('');
    onClose();
  };
  return <Dialog open={isOpen} onOpenChange={open => !open && onClose()}>
      <DialogContent className={cn("sm:max-w-md", resolvedTheme === 'dark' ? 'bg-netflix-black border-netflix-dark' : 'bg-background')}>
        <DialogHeader>
          <DialogTitle className="text-xl font-normal">
            Subscribe to our newsletter
          </DialogTitle>
          <DialogDescription className={resolvedTheme === 'dark' ? 'text-white/70' : 'text-black/70'}>
            Get access to exclusive content and be the first to know about new stories.
          </DialogDescription>
        </DialogHeader>
        
        <form onSubmit={handleSubscribe} className="space-y-4 mt-4">
          <div className="space-y-2">
            <label htmlFor="email-address" className={cn("block text-sm font-medium", resolvedTheme === 'dark' ? 'text-white' : 'text-black')}>
              Email address
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Mail className={resolvedTheme === 'dark' ? 'text-white/70' : 'text-black/70'} size={20} />
              </div>
              <Input id="email-address" type="email" placeholder="you@example.com" value={email} onChange={e => setEmail(e.target.value)} className={cn("pl-10", resolvedTheme === 'dark' ? 'bg-netflix-dark border-white/20 text-white' : 'bg-white border-gray-300')} required />
            </div>
          </div>
          
          <Button type="submit" className="w-full text-black font-medium bg-emerald-400 hover:bg-emerald-300">
            Subscribe
          </Button>
          
          <p className={cn("text-xs text-center", resolvedTheme === 'dark' ? 'text-white/50' : 'text-black/50')}>
            By subscribing, you agree to our terms of service and privacy policy.
          </p>
        </form>
      </DialogContent>
    </Dialog>;
};
export default SubscribeDialog;